import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { wrapPromise } from '../../../utils/promise';
import { saveRoute } from '../../../store/reducers/route';
import modals from '../../../enums/modals';
import { useModalContext } from '../../../components/ModalControlled/ModalProvider';

const useSummaryModalData = () => {
  const dispatch = useDispatch();
  const { getModalRef } = useModalContext();

  const onSaveClick = useCallback(() => dispatch(saveRoute()), [dispatch]);

  const openSummaryModal = useCallback(
    ({ isTransfer }) => {
      const summaryModalRef = getModalRef(modals.TRANSFER_SUMMARY);
      wrapPromise(
        summaryModalRef.current.showModal({
          isTransfer,
          onSaveClick,
        })
      );
    },
    [onSaveClick]
  );

  return {
    openSummaryModal,
  };
};

export default useSummaryModalData;
